export const checklistPages = [
  {
    title: 'Datos del Usuario',
    fields: [
      { id: 'profile_name', type: 'profile_name', label: 'Nombre Completo', required: true },
      { id: 'profile_company', type: 'profile_company', label: 'Empresa', required: true },
      { id: 'kilometraje', type: 'kilometraje', label: 'Kilometraje Actual', required: true },
      { id: 'documentacion', label: 'Documentación a Bordo', description: 'Carnet EMICAR, LAMA, Seguro, Habilitación, RTO', status: 'Falta' },
    ],
  },
  {
    title: 'Inspección Exterior',
    fields: [
      { id: 'lucesCriticas', label: 'Luces Críticas', description: 'Faros, Neblineros, Baliza, Estrobo y Pértiga', status: 'Con Fallas' },
      { id: 'lucesGenerales', label: 'Luces Generales', description: 'Posición, Balizas, Dirección, Freno y Retroceso', status: 'Con Fallas' },
      { id: 'perimetro', label: 'Perímetro', description: 'Espejos, Parabrisas, Ventanillas, N° Interno, CheckPoint y Calza', status: 'Con Detalles' },
    ],
  },
  {
    title: 'Inspección Interior',
    fields: [
      { id: 'seguridadInterior', label: 'Seguridad Interior', description: 'Limpiaparabrisas, Freno de mano y Cinturones de seguridad', status: 'Mal funcionamiento' },
      { id: 'tableroCabina', label: 'Tablero y Cabina', description: 'Luces de tablero, testigos y cabina', status: 'Mal Funcionamiento' },
      { id: 'combustible', type: 'combustible', label: 'Nivel de Combustible', required: true },
    ],
  },
  {
    title: 'Elementos de Seguridad',
    fields: [
      { id: 'presurizados', label: 'Presurizados', description: 'Matafuego, Tubo Oxígeno y Vigotera', status: 'Falta Carga' },
      { id: 'comunicacion', label: 'Comunicación', description: 'Radio base, GPS y Frecuencias (Const11 y Const12)', status: 'En Falta' },
    ],
  },
  {
    title: 'Fluidos y Herramientas',
    fields: [
      { id: 'fluidos', label: 'Fluidos', description: 'Nivel Aceite, Refrigerante, Freno y Embrague', status: 'Agregar' },
      { id: 'herramientas', label: 'Herramientas', description: 'Gato, Palanca, Llave cruz y Herramientas', status: 'En Falta o Rotas' },
      { id: 'kitEmergencia', label: 'Kit Emergencia', description: 'Baliza reflectiva, Botiquín y Linterna', status: 'En Falta' },
    ],
  },
  {
    title: 'Observaciones',
    fields: [
      { id: 'observaciones', type: 'textarea' },
      { id: 'fotos', type: 'file' },
    ],
  },
];

export const getCheckItemIds = (pages) => {
  return pages.flatMap(page =>
    page.fields.filter(f => !f.type || f.type === undefined).map(f => f.id)
  );
};
